<template>
  <Disclosure as="div" v-slot="{ open }" class="options">
    <h3 class="-my-3 flow-root">
      <DisclosureButton class="button">
        <span class="font-medium text-gray-900">
          <slot name="default">
          </slot>
          <span v-if="selected > 0">
           ({{ selected }})
          </span>
        </span>
        <span class="ml-6 flex items-center">
          <PlusIcon v-if="!open" class="h-5 w-5" aria-hidden="true" />
          <MinusIcon v-else class="h-5 w-5" aria-hidden="true" />
        </span>
      </DisclosureButton>
    </h3>
    <DisclosurePanel class="pt-6">
      <div class="space-y-4">
        <div v-for="option in options" :key="option.value" class="flex items-center">
          <input v-model="selection" :id="option.value" :value="option.value" type="checkbox" />
          <label :for="option.value" class="label">
            {{ option.label }}
          </label>
        </div>
      </div>
    </DisclosurePanel>
  </Disclosure>
</template>

<script setup>
import { computed, ref, watchEffect } from 'vue';

const props = defineProps({options: Array, modelValue: Array});
const emits = defineEmits(['update:modelValue']);

const selection = ref(new Array);
const selected = computed(() => selection.value.length);

const emitter = (value) => emits('update:modelValue', value);
const watcher = watchEffect(() => emitter(selection.value));
</script>

<style scoped>

.options
{
  @apply rounded-md bg-white;
  @apply py-4 px-4;
  @apply border-b border-gray-200;
}

.button
{
  @apply flex w-full items-center justify-between py-3;
  @apply text-sm text-gray-400 hover:text-gray-500;
}

input
{
  @apply h-4 w-4 rounded border-gray-300;
  @apply text-teal-600 focus:ring-teal-500;
}

label
{
  @apply ml-3 text-sm text-gray-600;
  @apply cursor-pointer;
}
</style>
